import type {ReactElement} from 'react';
import React from 'react';
import {getCurrentPage} from '@Components/poster-editor/poster-editor-reducer';
import {BackgroundTypeName} from '@PosterWhiteboard/page/background/background.class';
import {BaseItemSepiaOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-item-sepia-option';
import {useAppSelector} from '@/hooks';

export function ImageBgSepiaOption(): ReactElement<any> | null {
  const currentPageObject = useAppSelector(getCurrentPage);

  if (!currentPageObject) {
    return null;
  }

  if (currentPageObject.background.details.type !== BackgroundTypeName.IMAGE) {
    return null;
  }

  const onToggleOption = (): void => {
    const currentPage = window.posterEditor?.whiteboard?.getCurrentPage();
    if (!currentPage) {
      return;
    }
    if (!('imageBackgroundItemObject' in currentPageObject.background.details)) {
      throw new Error('Expected background to be of image type');
    }

    void currentPage.background.updateFromObject({
      details: {
        imageBackgroundItemObject: {
          effects: {
            sepia: !currentPageObject.background.details.imageBackgroundItemObject.effects.sepia,
          },
        },
      },
    });
  };

  return <BaseItemSepiaOption isChecked={currentPageObject.background.details.imageBackgroundItemObject.effects.sepia} onToggleOption={onToggleOption} />;
}
